export default __webpack_public_path__ + "static/dashboard-90c8c60755d331723f3efed498a03933.png";